import { render } from "./Iron.vue?vue&type=template&id=158f951a&scoped=true"
import script from "./Iron.vue?vue&type=script&lang=js"
export * from "./Iron.vue?vue&type=script&lang=js"

import "./Iron.vue?vue&type=style&index=0&id=158f951a&scoped=true&lang=scss"

import exportComponent from "D:\\work\\CodeV4\\FCP-Web-V4\\leanloop-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-158f951a"]])

export default __exports__